export const decodeSourceName = (name) => {
  try {
    return decodeURIComponent(name)
  } catch (error) {
    return name
  }
}